import React, { useState } from 'react';
import axios from 'axios';
import { notificar } from '../utils/notify';
import '../styles/fmp.css';

const MODELOS = {
  omie: { rotulo: 'Omie', modelo: 'ernedu', descricao: 'Estrutura copiada do banco ernedu (Escola de Risco)' },
  conta_azul: { rotulo: 'Conta Azul', modelo: 'texeirafmp', descricao: 'Estrutura copiada do banco texeirafmp (Teixeira Müller)' },
};

const CopiaBanco = () => {
  const [sistema, setSistema] = useState('omie');
  const [nomeBanco, setNomeBanco] = useState('');
  const [criando, setCriando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [mensagem, setMensagem] = useState('');

  const nomeValido = /^[a-z][a-z0-9_]{2,39}$/.test(nomeBanco);

  const criar = async () => {
    if (!nomeValido) {
      const msg = 'Nome inválido: só letras minúsculas, números e _, começando com letra (3 a 40 caracteres).';
      setMensagem(msg);
      notificar(msg);
      return;
    }
    const confirmar = window.confirm(
      `Criar o banco "${nomeBanco}" copiando a ESTRUTURA (sem dados) de "${MODELOS[sistema].modelo}"?`
    );
    if (!confirmar) return;

    setCriando(true);
    setResultado(null);
    setMensagem('');
    const token = localStorage.getItem('access');
    try {
      const r = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/admin/copiar-banco/`,
        { nome_banco: nomeBanco, sistema },
        { headers: { Authorization: `Bearer ${token}` }, timeout: 120000 }
      );
      if (r.data?.success) {
        setResultado(r.data);
        notificar(`Banco "${r.data.banco}" criado com ${r.data.total_tabelas} tabela(s)`);
        setNomeBanco('');
      } else {
        setMensagem(`${r.data?.erro || 'Erro ao criar banco'}`);
        notificar(`${r.data?.erro || 'Erro ao criar banco'}`);
      }
    } catch (e) {
      const erro = e.response?.data?.erro || 'Erro ao conectar com o servidor';
      setMensagem(`${erro}`);
      notificar(`${erro}`);
    } finally {
      setCriando(false);
    }
  };

  return (
    <div className="das-page fmp-brand-page">
      <div className="container mt-5 shadow p-4 rounded bg-white" style={{ maxWidth: 860 }}>
        <div className="header-wrapper d-flex align-items-center mb-4">
          <i className="fas fa-database header-icon me-2"></i>
          <div>
            <h2 className="titulo-pagina m-0">Copiar Banco FMP</h2>
            <small className="text-muted">Cria um banco novo com a estrutura do modelo (sem nenhum dado)</small>
          </div>
        </div>

        <div className="card mb-3" style={{ borderColor: '#00205b' }}>
          <div className="card-header text-white" style={{ backgroundColor: '#00205b' }}>
            <h6 className="mb-0"><i className="fas fa-copy me-2"></i>Novo banco</h6>
          </div>
          <div className="card-body">
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label small fw-semibold mb-1">Sistema (modelo)</label>
                <select className="form-select" value={sistema} onChange={(e) => setSistema(e.target.value)}>
                  <option value="omie">Omie — modelo ernedu</option>
                  <option value="conta_azul">Conta Azul — modelo texeirafmp</option>
                </select>
              </div>
              <div className="col-md-5">
                <label className="form-label small fw-semibold mb-1">Nome do banco novo</label>
                <input
                  type="text"
                  className={`form-control ${nomeBanco && !nomeValido ? 'is-invalid' : ''}`}
                  placeholder="ex.: novoclientefmp"
                  value={nomeBanco}
                  onChange={(e) => setNomeBanco(e.target.value.toLowerCase().trim())}
                  onKeyDown={(e) => { if (e.key === 'Enter') criar(); }}
                />
                <small className="text-muted">Minúsculas, números e _ — começando com letra</small>
              </div>
              <div className="col-md-3">
                <button
                  className="btn w-100 text-white"
                  style={{ backgroundColor: '#00205b' }}
                  disabled={criando || !nomeBanco}
                  onClick={criar}
                >
                  {criando ? (
                    <><span className="spinner-border spinner-border-sm me-2"></span>Criando...</>
                  ) : (
                    <><i className="fas fa-plus me-2"></i>Criar banco</>
                  )}
                </button>
              </div>
            </div>
            <div className="mt-2">
              <small className="text-muted">
                <i className="fas fa-info-circle me-1"></i>
                {MODELOS[sistema].descricao} — apenas a estrutura das tabelas é copiada, sem dados.
              </small>
            </div>
            {mensagem && <div className="alert alert-danger py-2 mt-3 mb-0">{mensagem}</div>}
          </div>
        </div>

        {resultado && (
          <div className="card" style={{ borderColor: '#1fa971' }}>
            <div className="card-header text-white" style={{ backgroundColor: '#1fa971' }}>
              <h6 className="mb-0">
                <i className="fas fa-check-circle me-2"></i>
                Banco "{resultado.banco}" criado — {resultado.total_tabelas} tabela(s) (modelo: {resultado.modelo})
              </h6>
            </div>
            <div className="card-body">
              <div className="d-flex flex-wrap gap-2">
                {resultado.tabelas_criadas.map((t) => (
                  <span key={t} className="badge bg-light text-dark border">{t}</span>
                ))}
              </div>
              {resultado.falhas?.length > 0 && (
                <div className="alert alert-warning py-2 mt-3 mb-0">
                  <strong>{resultado.falhas.length} tabela(s) falharam:</strong>
                  <ul className="mb-0">
                    {resultado.falhas.map((f) => <li key={f.tabela}><code>{f.tabela}</code> — {f.erro}</li>)}
                  </ul>
                </div>
              )}
              <div className="alert alert-info py-2 mt-3 mb-0">
                <i className="fas fa-lightbulb me-1"></i>
                Próximo passo: cadastrar o cliente no <strong>FMP</strong> apontando o campo <code>Database</code> para
                <code className="ms-1">{resultado.banco}</code>.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CopiaBanco;
